/* unplugin-vue-components disabled */import { render } from "./Template.vue?vue&type=template&id=b934aa72"
import script from "./Template.vue?vue&type=script&lang=js"
export * from "./Template.vue?vue&type=script&lang=js"

import "./Template.vue?vue&type=style&index=0&id=b934aa72&lang=css"

import exportComponent from "E:\\电梯项目文档\\lcFrontEnd\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__